import { observer } from 'mobx-react-lite';
import React from 'react';
import { Virtuoso } from 'react-virtuoso';
import { Box } from '@cad-arc';
import Skeleton from 'react-loading-skeleton';
import { FrQueueVirtuosoListWrapper } from './fr-queue-virtuoso-list-wrapper';
import { colors } from '../colors/colors';

export const FrLoadingQueueRows = observer(function FrLoadingQueueRows(): React.ReactElement {
    return (
        <Virtuoso
            key="loading-fr-events-list"
            style={{
                height: '100%',
                width: '100%',
            }}
            totalCount={30}
            components={{ List: FrQueueVirtuosoListWrapper }}
            computeItemKey={(index: number) => index}
            itemContent={() => (
                <Box px="2">
                    <Skeleton
                        baseColor={colors.skeletonBaseColor}
                        highlightColor={colors.skeletonHighlightColor}
                        height="104px"
                    />
                </Box>
            )}
        />
    );
});
